import { initAuthPages } from './pages/auth';
import { initOperationsIcons } from './common/operations-icons';
import { initSiteShell, showToast } from './common/site-shell';
import { initCreatorPortal } from './pages/creator-portal';
import { initOperationsAdmin } from './pages/operations-admin';
import { initPublicPages } from './pages/public';
import { initTextLengthCounters } from './common/text-length';

document.documentElement.classList.add('js');

initOperationsIcons();
initSiteShell();
initPublicPages();
initAuthPages();
initCreatorPortal();
initOperationsAdmin();
initTextLengthCounters();

const initialToast = document.querySelector('[data-initial-toast]');
if (initialToast instanceof HTMLElement && initialToast.dataset.initialToast) {
    showToast(initialToast.dataset.initialToast);
}
